var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("在岗人数：200 进场人数：100 出场人数：80")]),_c('div',[_vm._v("场内人数：200 劳务工人：100 管理人员：80")]),_c('div',[_vm._v("出勤率：50%")])])}]

export { render, staticRenderFns }